import React from 'react';
import './ProfessionalPage.css'; // Reusing existing CSS file for simplicity

const Diagrams = ({ type, data }) => {
    if (!data) return null;

    switch (type) {
        case 'pyramid':
            return <PyramidDiagram data={data} />;
        case 'cycle':
            return <CycleDiagram data={data} />;
        case 'quadrant':
            return <QuadrantDiagram data={data} />;
        case 'pillars':
            return <PillarsDiagram data={data} />;
        default:
            return null;
    }
};

const PyramidDiagram = ({ data }) => {
    // data: { levels: [{ label: "Level 1", color: "#..." }] } - bottom to top
    return (
        <div className="diagram-container pyramid-container">
            {data.levels.map((level, index) => (
                <div
                    key={index}
                    className="pyramid-level"
                    style={{
                        backgroundColor: level.color,
                        width: `${100 - (index * (100 / data.levels.length))}%`,
                        zIndex: data.levels.length - index
                    }}
                >
                    <span className="level-text">{level.label}</span>
                </div>
            ))}
        </div>
    );
};

const CycleDiagram = ({ data }) => {
    // data: { steps: [{ label: "Plan" }] }
    return (
        <div className="diagram-container cycle-container">
            {data.steps.map((step, index) => (
                <div key={index} className="cycle-item">
                    <div className="cycle-circle">
                        <span className="step-number">{index + 1}</span>
                    </div>
                    <div className="cycle-text">
                        <span className="step-label">{step.label}</span>
                    </div>
                    {index < data.steps.length - 1 && <div className="cycle-arrow">→</div>}
                </div>
            ))}
        </div>
    );
};

const QuadrantDiagram = ({ data }) => {
    // data: { x: "Urgency", y: "Importance", quadrants: [{ label: "Do", color: "red", desc: "..." }] }
    return (
        <div className="diagram-container quadrant-wrapper">
            <div className="y-axis-label">{data.y}</div>
            <div className="quadrant-grid">
                {data.quadrants.map((q, i) => (
                    <div key={i} className="quadrant-box" style={{ backgroundColor: q.color }}>
                        <span className="quadrant-title">{q.label}</span>
                        <span className="quadrant-desc">{q.desc}</span>
                    </div>
                ))}
            </div>
            <div className="x-axis-label">{data.x}</div>
        </div>
    );
};

const PillarsDiagram = ({ data }) => {
    // data: { roof: "Success", pillars: [{ label: "Reliability", desc: "Uptime" }], foundation: "Foundation" }
    return (
        <div className="diagram-container pillars-wrapper">
            <div className="pillars-roof">
                <span>{data.roof}</span>
            </div>
            <div className="pillars-row">
                {data.pillars.map((pillar, i) => (
                    <div key={i} className="pillar-column">
                        <div className="pillar-cap"></div>
                        <div className="pillar-body">
                            <span className="pillar-title">{pillar.label}</span>
                            <span className="pillar-desc">{pillar.desc}</span>
                        </div>
                        <div className="pillar-base"></div>
                    </div>
                ))}
            </div>
            <div className="pillars-foundation">
                <span>{data.foundation}</span>
            </div>
        </div>
    );
};

export default Diagrams;
